import TagsComponent from './TagsComponent';

export default TagsComponent;
